import React from "react";
import { FormMock } from "./split-test.styles";

// Miniature of the classic order form (ContactInfoForm in the funnel-app):
// shows where the tested element sits and highlights it. Typed elements:
// colours restyle the button / header bar, features show the social-proof
// line or the rating badge.
const DEFAULTS = {
  formScreenHeader: "✓ Glückwunsch",
  formScreenSubtext: "Wir haben das passende Angebot für Sie gefunden.",
  formHeadline: "Erhalten Sie jetzt unverbindlich und kostenlos ein Angebot",
  subHeadlineForm: "Wie können wir Sie kontaktieren?",
  fieldTitleName: "Vor- & Nachname",
  fieldPlaceholderName: "Vor- & Nachname",
  fieldTitleEmail: "E-Mail",
  fieldPlaceholderEmail: "E-Mail-Adresse",
  fieldTitlePhone: "Telefon",
  fieldPlaceholderPhone: "Telefon (für eventuelle Rückfragen)",
  submitButton: "Jetzt Angebot erhalten",
  submitButtonSubtext: "(kostenlos und unverbindlich)"
};

export const HARD_CODED_COLORS = {
  submitButtonBackground: "#e15d3a",
  formHeaderBackground: "#198754"
};

const COLOR_ELEMENTS = ["submitButtonBackground", "formHeaderBackground"];
const FEATURE_ELEMENTS = ["socialProof", "googleRating"];

const VariantPreview = ({
  element,
  value,
  funnelType,
  colours = {},
  socialProof = null,
  googleRating = null
}) => {
  const texts = {
    ...DEFAULTS,
    ...(funnelType === "EMPLOYEE"
      ? {
          formScreenHeader: "Glückwunsch",
          formScreenSubtext: "Deine Bewerbung ist fast vollständig!",
          formHeadline:
            "Schließe nun deine Bewerbung für das Stellenangebot ab!",
          subHeadlineForm: "Wie können wir dich erreichen?",
          fieldPlaceholderPhone: "Telefon (für Rückfragen)",
          submitButton: "Jetzt Bewerbung absenden",
          submitButtonSubtext: ""
        }
      : {})
  };
  const isColor = COLOR_ELEMENTS.includes(element);
  const isFeature = FEATURE_ELEMENTS.includes(element);
  if (element && !isColor && !isFeature && value !== undefined) {
    texts[element] = value;
  }
  const effectiveColours = { ...HARD_CODED_COLORS, ...colours };
  if (isColor && value) effectiveColours[element] = value;
  let line = socialProof;
  let badge = googleRating;
  if (isFeature) {
    const enabled = Boolean(value?.enabled);
    if (element === "socialProof") {
      line = enabled
        ? {
            label: (
              value?.template ||
              "Diese Woche haben {{count}} Hausbesitzer eine Anfrage für {{category}} gestellt"
            )
              .replace("{{count}}", "212")
              .replace(
                "{{category}}",
                funnelType === "EMPLOYEE" ? "Anlagenmechaniker" : "Badsanierung"
              )
          }
        : null;
    }
    if (element === "googleRating") {
      badge = enabled ? { rating: 4.8, count: 37 } : null;
    }
  }
  const cls = (key) => (key === element ? "hl" : "");
  return (
    <FormMock aria-label="Formular-Vorschau">
      <div
        className={`bar ${cls("formHeaderBackground")}`}
        style={{ background: effectiveColours.formHeaderBackground }}
      >
        <span className={cls("formScreenHeader")}>
          {texts.formScreenHeader}
        </span>
        <small className={cls("formScreenSubtext")}>
          {texts.formScreenSubtext}
        </small>
      </div>
      <div className="body">
        <div className={`headline ${cls("formHeadline")}`}>
          {texts.formHeadline}
        </div>
        <div className={`sub ${cls("subHeadlineForm")}`}>
          {texts.subHeadlineForm}
        </div>
        {line?.label && (
          <div className={`social ${cls("socialProof")}`}>{line.label}</div>
        )}
        <div className="field">
          <b className={cls("fieldTitleName")}>{texts.fieldTitleName}</b>
          <span className={cls("fieldPlaceholderName")}>
            {texts.fieldPlaceholderName}
          </span>
        </div>
        <div className="field">
          <b className={cls("fieldTitleEmail")}>{texts.fieldTitleEmail}</b>
          <span className={cls("fieldPlaceholderEmail")}>
            {texts.fieldPlaceholderEmail}
          </span>
        </div>
        <div className="field">
          <b className={cls("fieldTitlePhone")}>{texts.fieldTitlePhone}</b>
          <span className={cls("fieldPlaceholderPhone")}>
            {texts.fieldPlaceholderPhone}
          </span>
        </div>
        {badge?.rating && (
          <div className={`rating ${cls("googleRating")}`}>
            <span className="stars">
              {"★★★★★".slice(0, Math.round(badge.rating))}
            </span>{" "}
            <b>
              {Number(badge.rating).toLocaleString("de-DE", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
              })}
            </b>{" "}
            · {badge.count} Google-Bewertungen
          </div>
        )}
        <div
          className={`btn-mock ${cls("submitButton")} ${cls("submitButtonBackground")}`}
          style={{ background: effectiveColours.submitButtonBackground }}
        >
          {texts.submitButton}
        </div>
        <div className={`btn-sub ${cls("submitButtonSubtext")}`}>
          {texts.submitButtonSubtext}
        </div>
      </div>
    </FormMock>
  );
};

export default VariantPreview;
